module.exports = __webpack_public_path__ + "static/favicon-3a7d95627049a70e0b592d15140b0e44.ico";